export const PATH = {
  TOP: '/',
  LOGIN: '/login/',
  DEMO: '/demo/',
  DEMO_LIPSYNC_AI: '/demo/lipsync-ai/',
  DEMO_DOWNLOAD: '/demo/download/',
  PAGE404: '/404/',
};
